module.exports = __webpack_public_path__ + "static/media/bang.dea0773f.svg";